const HoldingRegister = {
  HoldingRegister: "HoldingRegister.HoldingRegister",
  HoldingRegisterDescription: "HoldingRegister.HoldingRegisterDescription",
  HoldingRegisterFor: "HoldingRegister.HoldingRegisterFor",
  AssetAccount: "HoldingRegister.AssetAccount",
  DepreciatingAccount: "HoldingRegister.DepreciatingAccount",
  NumberOfAssets: "HoldingRegister.NumberOfAssets",
  PurchaseValue: "HoldingRegister.PurchaseValue",
  AccumulatedDepreciation: "HoldingRegister.AccumulatedDepreciation",
  BookValue: "HoldingRegister.BookValue",
  ActualBookedValue: "HoldingRegister.ActualBookedValue",
  ExpenseAccount: "HoldingRegister.ExpenseAccount",
  AcquisitionDate: "HoldingRegister.AcquisitionDate",
  Expires: "HoldingRegister.Expires",
  ResidualValue: "HoldingRegister.ResidualValue",
  DeptPerMonth: "HoldingRegister.DeptPerMonth",
  AlasDepreciation: "HoldingRegister.AlasDepreciation",
  DeptDegree: "HoldingRegister.DeptDegree",
  Depreciation: "HoldingRegister.Depreciation",
  Removed: "HoldingRegister.Removed",
  HaveVerification: "HoldingRegister.HaveVerification",
  }
export default HoldingRegister;